import { co } from "@fullcalendar/core/internal-common";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import React from "react";

import ComingSoon from "layouts/pages/users/reports/ComingSoonPage";

export const templates = [
  {
    id: 1,
    name: "Serie di Benvenuto",
    description: "Sequenza di email formata da 3 step, utile ad accogliere i nuovi lead.",
    category: "email",
    image:
      "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "popular",
    steps: 3,
    comingSoon: false,
  },
  {
    id: 2,
    name: "Promemoria di Follow-up",
    description: "Sequenza automatica di follow-up dopo il primo contatto",
    category: "whatsapp",
    image:
      "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "new",
    steps: 4,
    ComingSoon: true,
  },
  {
    id: 3,
    name: "Promemoria Appuntamento",
    description: "Sequenza SMS per appuntamenti imminenti",
    category: "sms",
    image:
      "https://images.unsplash.com/photo-1506784365847-bbad939e9335?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "standard",
    steps: 2,
    comingSoon: true,
  },
  {
    id: 4,
    name: "Campagna di Riattivazione",
    description: "Riconquista i tuoi clienti inattivi con questa serie di email.",
    category: "email",
    image:
      "https://images.unsplash.com/photo-1512428559087-560fa5ceab42?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "popular",
    steps: 5,
    comingSoon: false,
  },
  {
    id: 5,
    name: "Feedback sul Servizio",
    description: "Raccogli feedback dopo l'erogazione del servizio",
    category: "multi",
    image:
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "standard",
    steps: 3,
    comingSoon: true,
  },
  {
    id: 6,
    name: "Onboarding del Prodotto",
    description: "Aiuta un segmento di utenti a conoscere meglio il tuo prodotto o servizio.",
    category: "email",
    image:
      "https://images.unsplash.com/photo-1531379410502-63bfe8cdaf6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "popular",
    steps: 7,
    comingSoon: false,
  },
  {
    id: 7,
    name: "Sequenza Chiamate di Vendita",
    description: "Sequenza strutturata per i follow-up delle chiamate di vendita",
    category: "call",
    image:
      "https://images.unsplash.com/photo-1596524430615-b46475ddff6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "new",
    steps: 4,
    comingSoon: true,
  },
  {
    id: 8,
    name: "Percorso di Nurturing Lead",
    description: "Sequenza a lungo termine per coltivare i lead fino alla conversione",
    category: "nurture",
    image:
      "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&h=200&q=80",
    popularity: "standard",
    steps: 8,
    comingSoon: true,
  },
];

export const mockMessages = {
  // Modelli Email
  email: [
    {
      subject: "Benvenuto nella nostra community!",
      content:
        "Ciao {{firstName}},\n\nBenvenuto sulla nostra piattaforma! Siamo entusiasti di averti nella nostra community.\n\nEcco alcuni consigli per iniziare:\n- Completa il tuo profilo\n- Esplora le nostre funzionalità\n- Connettiti con altri utenti\n\nSe hai domande, rispondi pure a questa email.\n\nCordiali saluti,\nIl Team di {{businessName}}",
    },
    {
      subject: "Sfrutta al massimo il tuo abbonamento",
      content:
        "Ciao {{firstName}},\n\nAbbiamo notato che sei con noi da alcuni giorni. Come ti stai trovando?\n\nEcco alcune funzionalità avanzate che potresti voler esplorare:\n- Report personalizzati\n- Opzioni di integrazione\n- Servizi premium\n\nFacci sapere se hai bisogno di aiuto!\n\nA presto,\nIl Team di {{businessName}}",
    },
    {
      subject: "Offerta speciale solo per te!",
      content:
        "Caro {{firstName}},\n\nCome nostro membro stimato, siamo lieti di offrirti uno sconto esclusivo sui nostri servizi premium. Usa il codice WELCOME20 per ottenere il 20% di sconto sul tuo primo upgrade.\n\nL'offerta scade tra 7 giorni, non perdere l'occasione!\n\nGrazie per far parte del nostro viaggio,\nIl Team di {{businessName}}",
    },
  ],

  // Modelli WhatsApp
  whatsapp: [
    {
      content:
        "Ciao {{firstName}}! Grazie per averci contattato su {{businessName}}. Abbiamo ricevuto la tua richiesta e ti risponderemo a breve. Salva questo numero per restare aggiornato!",
    },
    {
      content:
        "Ciao {{firstName}}! Solo un rapido controllo: hai domande sui nostri servizi? Siamo qui per aiutarti! {{businessName}}",
    },
    {
      content:
        "Ciao {{firstName}}! Abbiamo notato il tuo interesse per il nostro servizio {{service}}. Ti piacerebbe fissare una consulenza gratuita? Rispondi indicando un orario comodo. {{businessName}}",
    },
    {
      content:
        "Grazie per il tuo interesse, {{firstName}}! Ecco le informazioni sui prezzi che hai richiesto: {{pricingInfo}}. Facci sapere se desideri procedere. {{businessName}}",
    },
  ],

  // Modelli SMS
  sms: [
    {
      content:
        "Promemoria {{businessName}}: Il tuo appuntamento è previsto per domani alle {{time}}. Rispondi Y per confermare o chiamaci al {{phone}} per riprogrammare.",
    },
    {
      content:
        "{{firstName}}, grazie per aver scelto {{businessName}}. Come valuteresti la tua recente esperienza? Rispondi da 1 a 5 (5 = eccellente).",
    },
  ],

  // Script di Chiamata
  call: [
    {
      content:
        "Introduzione: Ciao [Nome Cliente], sono [Tuo Nome] di [Azienda]. Ti chiamo per il tuo recente interesse verso [Prodotto/Servizio].\n\nPunti chiave:\n- Ringraziare per l'interesse\n- Chiedere delle loro esigenze specifiche\n- Spiegare come la nostra soluzione risponde alle loro necessità\n- Rispondere a eventuali domande\n\nChiusura: Saresti disponibile per una demo di 15 minuti la prossima settimana? Ho disponibilità martedì alle 14:00 o mercoledì alle 10:00.",
    },
    {
      content:
        "Script di Follow-up:\n\nSaluto: Ciao [Nome Cliente], sono [Tuo Nome] di [Azienda]. Abbiamo parlato [giorno] riguardo a [argomento].\n\nObiettivo: Ti chiamo per sapere se hai avuto modo di valutare [proposta/prodotto].\n\nPunti di discussione:\n- Rispondere a domande emerse nella precedente chiamata\n- Evidenziare 2-3 benefici chiave pertinenti alla loro situazione\n- Discutere i prossimi passi\n\nChiusura: In base alla nostra conversazione, vogliamo fissare una demo oppure preferisci che ti invii una proposta dettagliata?",
    },
    {
      content:
        "Script per Gestione Obiezioni:\n\nSe l'obiezione è sul prezzo: Capisco che il budget sia una preoccupazione. Molti nostri clienti inizialmente pensavano lo stesso, ma hanno riscontrato che il ROI nei primi 3 mesi giustificava l'investimento grazie a [beneficio specifico].\n\nSe l'obiezione è sui tempi: Capisco che la tempistica sia importante. Che ne dici di iniziare con un programma pilota più piccolo, con un impegno ridotto, ma che dimostri comunque il valore?\n\nSe l'obiezione è sulla concorrenza: Grazie per averlo condiviso. Anche se [Concorrente] offre un buon prodotto, la nostra soluzione si distingue in tre aspetti chiave che i nostri clienti trovano molto vantaggiosi: [elenco dei punti di forza].",
    },
  ],

  // Modelli di Nurturing Lead
  nurture: [
    {
      subject: "Penso che questo ti possa interessare",
      content:
        "Ciao {{firstName}},\n\nMi sono imbattuto in questo articolo su [argomento legato alla loro industria] e ho subito pensato a te.\n\nEcco il link: {{articleLink}}\n\nSpero ti sia utile!\n\nCordiali saluti,\n{{senderName}} di {{businessName}}",
    },
    {
      subject: "Una rapida domanda sui tuoi obiettivi",
      content:
        "Ciao {{firstName}},\n\nSpero che questa email ti trovi bene.\n\nStavo riflettendo sulla tua situazione riguardo a [sfida specifica menzionata] e sono curioso: quale sarebbe per te il risultato ideale nei prossimi 6 mesi?\n\nHo alcune idee che potrebbero aiutarti, ma volevo prima assicurarmi di capire correttamente le tue priorità.\n\nIn attesa di un tuo riscontro,\n{{senderName}}",
    },
    {
      subject: "Una risorsa che potrebbe piacerti",
      content:
        "Ciao {{firstName}},\n\nBasandomi sulle nostre conversazioni precedenti su [loro interesse], ho pensato che potresti trovare utile la nostra ultima guida.\n\nEssa tratta:\n- [Punto chiave 1]\n- [Punto chiave 2]\n- [Punto chiave 3]\n\nPuoi scaricarla qui: {{resourceLink}}\n\nSe hai domande, non esitare a contattarmi!\n\nUn saluto,\n{{senderName}}",
    },
  ],

  // Modelli Multi-Canale
  multi: [
    {
      type: "email",
      subject: "Grazie per il tuo acquisto!",
      content:
        "Caro {{firstName}},\n\nGrazie per aver scelto {{businessName}}! Stiamo elaborando il tuo ordine e ti invieremo presto le informazioni di tracciamento.\n\nNel frattempo, dai un'occhiata alle nostre guide per prenderti cura del tuo nuovo acquisto: {{careGuideLink}}\n\nCordiali saluti,\nIl Team di {{businessName}}",
    },
    {
      type: "sms",
      content:
        "{{businessName}}: Il tuo ordine n°{{orderNumber}} è stato spedito! Traccialo qui: {{trackingLink}}. Domande? Rispondi a questo messaggio o chiamaci al {{supportPhone}}.",
    },
    {
      type: "email",
      subject: "Come ti trovi con il tuo acquisto?",
      content:
        "Ciao {{firstName}},\n\nSperiamo che tu stia apprezzando il tuo recente acquisto su {{businessName}}!\n\nCi farebbe piacere ricevere un tuo feedback. Ti va di rispondere a un rapido sondaggio di 2 minuti? {{surveyLink}}\n\nCome ringraziamento, ti invieremo un codice sconto del 10% per il tuo prossimo acquisto.\n\nGrazie ancora!\nIl Team di {{businessName}}",
    },
  ],
};

export const templateCategories = [
  { id: "email", name: "Campagne Email", icon: <EmailIcon fontSize="large" /> },
  { id: "whatsapp", name: "Follow-up di WhatsApp", icon: <WhatsAppIcon fontSize="large" /> },
  { id: "sms", name: "Campagne SMS", icon: <ChatIcon fontSize="large" /> },
  { id: "call", name: "Sequenze di chiamata", icon: <PhoneIcon fontSize="large" /> },
  { id: "nurture", name: "Sviluppo dei lead", icon: <AutoGraphIcon fontSize="large" /> },
  { id: "multi", name: "Multi-Channel", icon: <GroupAddIcon fontSize="large" /> },
];
